// notification.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' }) // Makes it globally available
export class NotificationService {
  constructor(
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  showSuccess(
    detail: string = 'تمت إضافة الدورة بنجاح',
    summary: string = 'تمت الإضافة بنجاح'
  ) {
    const translatedDetail = this.translate.instant(detail) || detail;
    const translatedSummary = this.translate.instant(summary) || summary;
    this.messageService.add({
      severity: 'success',
      summary: translatedSummary,
      detail: translatedDetail,
      life: 4000,
      key: 'main-toast',
    });
    this.messageService.add({
      severity: 'success',
      summary: translatedSummary,
      detail: translatedDetail,
      life: 4000,
    });
  }

  showError(detail: string = 'حدث خطأ غير متوقع', summary: string = 'خطأ') {
    const translatedDetail = this.translate.instant(detail) || detail;
    const translatedSummary = this.translate.instant(summary) || summary;
    this.messageService.add({
      severity: 'error',
      summary: translatedSummary,
      detail: translatedDetail,
      life: 5000,
      key: 'main-toast',
    });
    this.messageService.add({
      severity: 'error',
      summary: translatedSummary,
      detail: translatedDetail,
      life: 5000,
    });
  }

  showInfo(detail: string, summary: string = 'Info') {
    this.messageService.add({
      severity: 'info',
      summary: summary,
      detail: detail,
      life: 5000,
    });
  }
  private getTranslatedMessage(
    detailKey: string,
    summaryKey: string,
    params?: any
  ) {
    return this.translate.get([detailKey, summaryKey], params);
  }
  private getInstantTranslatedMessage(title: string) {
    return this.translate.instant(title);
  }

  // RTL/LTR support (optional)
  private getToastDirection(): string {
    return this.translate.currentLang === 'ar' ? 'rtl' : 'ltr';
  }
}
